var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"identify-fields-container"},[_c('IdentifyInputsRenderer',{attrs:{"inputs":this.wizardFields,"provider":_vm.selectedProvider,"handleInputChange":_vm.handleInputChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }